import React from 'react';

import { Box, Button, Flex, Icon, Tag, Td, Text, Tr } from '@chakra-ui/react';
import { Plus } from '@phosphor-icons/react';
import PropTypes from 'prop-types';
import { HiOutlineClock, HiOutlineLightningBolt } from 'react-icons/hi';

import {
  formatDelay,
  getNotificationGroupMethodLabel,
} from './helpers/complianceHelpers';
import { PolicyComplianceIndicator } from './NotificationPolicy/PolicyComplianceIndicator';

export const UnmetPolicyRow = ({
  policy,
  onAddToSatisfy,
  readOnly = false,
}) => {
  const policyLabel = getNotificationGroupMethodLabel(
    policy.notification_group_method,
  );
  const delayLabel = formatDelay(policy.max_delay);
  const isImmediate = policy.max_delay === 'PT0S';

  return (
    <Tr backgroundColor="surface.primary">
      {/* Type column */}
      <Td maxWidth={{ base: '120px', md: 'none' }}>
        <Flex alignItems="center" gap="2" overflow="hidden">
          <Box title={policyLabel}>
            <Text textStyle="body2" color="content.tertiary" fontStyle="italic">
              {policyLabel}
            </Text>
          </Box>
        </Flex>
      </Td>

      {/* Delay column */}
      <Td>
        <Tag variant="roundedOutline" size={{ base: 'sm', md: 'md' }}>
          {isImmediate ? (
            <Icon as={HiOutlineLightningBolt} mr="1" color="content.tertiary" />
          ) : (
            <Icon as={HiOutlineClock} mr="1" color="content.tertiary" />
          )}
          <Text
            display={{ base: isImmediate ? 'none' : 'block', md: 'block' }}
            textStyle="body2"
            color="content.tertiary"
          >
            {isImmediate ? delayLabel : `Within ${delayLabel}`}
          </Text>
        </Tag>
      </Td>

      {/* In Policy column */}
      <Td width={{ base: '60px', md: 'auto' }} textAlign="center">
        <PolicyComplianceIndicator
          isCompliant={false}
          size="sm"
          showLabel={false}
          userId=""
        />
      </Td>

      {/* Policy column */}
      <Td display={{ base: 'none', md: 'table-cell' }}>
        <Text textStyle="body2" color="content.feedback.error.secondary">
          Required by policy
        </Text>
      </Td>

      {/* Actions column */}
      <Td>
        <Flex justifyContent="flex-end">
          {!readOnly && (
            <Button
              size="xs"
              leftIcon={<Icon as={Plus} />}
              onClick={() => onAddToSatisfy(policy)}
              data-testid="add-to-satisfy-policy"
            >
              Add
            </Button>
          )}
        </Flex>
      </Td>
    </Tr>
  );
};

UnmetPolicyRow.propTypes = {
  policy: PropTypes.shape({
    id: PropTypes.string.isRequired,
    notification_group_method: PropTypes.string.isRequired,
    max_delay: PropTypes.string.isRequired,
    priority: PropTypes.string.isRequired,
  }).isRequired,
  onAddToSatisfy: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
};
